"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ripple = void 0;
var ripple_1 = require("./ripple");
Object.defineProperty(exports, "Ripple", { enumerable: true, get: function () { return ripple_1.Ripple; } });
//# sourceMappingURL=index.js.map